import Campaign from '../store/Campaign';
import { CAMPAIGN_ENDED } from './eventNames';
import { CampaignEndSignal } from '../store/schema/CampaignEndSignal';
import { getOpxHostAppName } from 'mini-opx-config/lib/getOpxHostAppName';
import { setCampaignVisibility } from '../mutators/setCampaignVisibility';

/**
 * Function to end the campaign and set the campaign view state to false
 * @param campaign Campaign object
 */
export const endCampaign = <T extends {}>(campaign: Campaign<T>, endSignal: CampaignEndSignal) => {
    campaign?.promiseResolve?.(null);
    const { logState, logger } = campaign;
    if (logState && !logState[CAMPAIGN_ENDED]) {
        logger?.(
            CAMPAIGN_ENDED,
            { id: campaign.getRemoteCampaignId(), hostApp: getOpxHostAppName() },
            { isCore: true }
        );
        logState[CAMPAIGN_ENDED] = true;
    }

    const campaignId = campaign.getRemoteCampaignId();
    /**
     * In carousel campaigns, user can swipe across carousel to view all campaigns.
     * In such a case, when the campaign is unmounting without any user action (click/dismiss), no end call is sent to the IRIS.
     */
    const isCarouselCampaignUnmounting = () => {
        const isPartOfCarousel = (campaign.getRenderProps() as any)?.isPartOfCarousel;
        return (
            isPartOfCarousel &&
            JSON.parse(isPartOfCarousel) &&
            endSignal === CampaignEndSignal.OnUnmount
        );
    };

    if (campaignId && !isCarouselCampaignUnmounting()) {
        campaign.getRemoteSource().end(campaignId, endSignal);
    }
    setCampaignVisibility(campaign, false);
};
